import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardBoxComponent } from './dashboard-box/dashboard-box.component';
import { DashboardMessagingComponent } from './dashboard-messaging/dashboard-messaging.component';
import { DashboardSolutionInfoComponent } from './dashboard-solution-info/dashboard-solution-info.component';
import { DashboardStatsComponent } from './dashboard-stats/dashboard-stats.component';

@NgModule({
	declarations: [
		DashboardComponent,
		DashboardBoxComponent,
		DashboardMessagingComponent,
		DashboardSolutionInfoComponent,
		DashboardStatsComponent
	],
	imports: [SharedModule]
})
export class DashboardModule {}
